if (!customElements.get('pl-recovery-vin')) {
  customElements.define('pl-recovery-vin', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.input = this.querySelector('input');
      this.field = this.querySelector('[data-vin-field]');
      this.requiredVariants = new Set(this.dataset.requiredVariants.split(','));
      this.onChange = (event) => {
        if (event.target.name === 'id') this.refresh();
      };
      this.onInput = () => {
        this.input.value = this.input.value.replace(/\s/g, '').toUpperCase();
      };
      this.form?.addEventListener('change', this.onChange);
      this.input.addEventListener('input', this.onInput);
      this.refresh();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('change', this.onChange);
      this.input?.removeEventListener('input', this.onInput);
    }

    refresh() {
      const variantId = this.form?.querySelector('[name="id"]')?.value;
      const required = this.requiredVariants.has(variantId);
      this.field.hidden = !required;
      this.input.disabled = !required;
      this.input.required = required;
    }

    prepareForSubmit() {
      this.refresh();
      this.onInput();
    }
  });
}
